import { useMutation } from "react-query";
import api from "../../../client";
import { CreateUserContactPayload } from "../../../types/user";

const postData = async (payload: CreateUserContactPayload): Promise<{}> => {
  // TODO: response type
  const { data } = await api.post<{}>(`/user/contact`, payload);

  return data;
};

export const useCreateUserContact = () => {
  return useMutation((payload: CreateUserContactPayload) => {
    return postData(payload);
  });
};
